<form [formGroup]="formGroup" (submit)="isFormValid()" fxLayout="column" fxLayoutAlign="center center" class="height-100">
  <div class="width-100">
    <mat-toolbar fxLayout="row">
      <button mat-icon-button [matTooltip]="'LABEL_CLOSE' | translate" (click)="confirmChanges()" type="button">
        <mat-icon svgIcon="close"></mat-icon>
      </button>
      <span fxFlex></span>
      <span class="mat-detail-header text-align-center">
        {{ detail?.id ? ('LABEL_EDIT_TYPE' | translate : { type: 'LABEL_COMPANY' | translate }) : ('LABEL_ADD_NEW' | translate : { type: 'LABEL_COMPANY' | translate }) }}
      </span>
      <span fxFlex></span>
      <button mat-icon-button [matTooltip]="'LABEL_SAVE' | translate" type="submit" [disabled]="disableSaveBtn()">
        <mat-icon svgIcon="check"></mat-icon>
      </button>
      <input #inputFile type="file" (change)="companyMntSvc.chooseFile($event, inputFile, formGroup); inputFile.value = ''" hidden="true" accept=".jpg, .png, .gif">
    </mat-toolbar>
  </div>

  <div fxLayout="column" class="padding-25 width-100 overflow-auto" fxFlex>
    <!-- prefix hidden bec no longer needs to be displayed -->
    <!-- <div fxLayout>
      <mat-form-field>
        <input
          #prefix
          matInput
          required
          autocomplete="off" 
          formControlName="prefix" 
          [placeholder]="'LABEL_PREFIX' | translate"
          >

        <mat-error *ngIf="formGroup.get('prefix').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>   

        <mat-error *ngIf="formGroup.get('prefix').hasError('maxlength')">
          {{ 'MSG_MAXLENGTH' | translate: {length: '2'} }}
        </mat-error>

        <mat-error *ngIf="formGroup.get('prefix').hasError('pattern')">
          {{ 'MSG_NO_SPECIAL_CHARS' | translate }}
        </mat-error> 
      </mat-form-field>
    </div> -->

    <!-- code -->
    <div fxLayout *ngIf="detail?.id">
      <mat-form-field>
        <input
          #code
          matInput
          autocomplete="off" 
          formControlName="code" 
          [placeholder]="'LABEL_CODE' | translate"
          >

        <mat-error *ngIf="formGroup.get('code').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>   

        <mat-error *ngIf="formGroup.get('code').hasError('maxlength')">
          {{ 'MSG_MAXLENGTH' | translate: {length: '8'} }}
        </mat-error>

        <mat-error *ngIf="formGroup.get('code').hasError('pattern')">
          {{ 'MSG_NO_SPECIAL_CHARS' | translate }}
        </mat-error> 
      </mat-form-field>
    </div>

    <!-- description -->
    <div fxLayout>
      <mat-form-field>
        <input 
          matInput
          required
          #description 
          autocomplete="off" 
          formControlName="description" 
          [placeholder]="'LABEL_DESCRIPTION' | translate"
          >

        <mat-error *ngIf="formGroup.get('description').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>   

        <mat-error *ngIf="formGroup.get('description').hasError('maxlength')">
          {{ 'MSG_MAXLENGTH' | translate: {length: '50'} }}
        </mat-error>

        <mat-error *ngIf="formGroup.get('description').hasError('pattern')">
          {{ 'MSG_NO_SPECIAL_CHARS' | translate }}
        </mat-error> 
      </mat-form-field>
    </div>

    <!-- country -->
    <esc-country-dropdown
      class="width-100" 
      [formWrapperFlex]="'none'"
      [wrapperLayoutAlign]="'start center'"
      [previousData]="detail"
      [disabled]="true"
      >
    </esc-country-dropdown>

    <!-- region -->
    <esc-region-dropdown
      class="width-100" 
      [formWrapperFlex]="'none'"
      [wrapperLayoutAlign]="'start center'"
      [previousData]="detail"
      [disabled]="true"
      >
    </esc-region-dropdown>

    <!-- province -->
    <esc-province-dropdown
      class="width-100" 
      [formWrapperFlex]="'none'"
      [wrapperLayoutAlign]="'start center'"
      [previousData]="detail"
      [disabled]="true"
      >
    </esc-province-dropdown>

    <!-- city -->
    <esc-city-dropdown
      class="width-100" 
      [formWrapperFlex]="'none'"
      [wrapperLayoutAlign]="'start center'"
      (optionSelected)="citySelected($event)"
      [previousData]="detail"
      [requiredError]="cityRequired"
      [disabled]="isDisabled"
      >
    </esc-city-dropdown>

    <!-- street -->
    <div fxLayout>
      <mat-form-field>
        <input 
          matInput
          required
          #street 
          autocomplete="off" 
          formControlName="street" 
          [placeholder]="'LABEL_STREET' | translate"
          >

        <mat-error *ngIf="formGroup.get('street').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>   

        <mat-error *ngIf="formGroup.get('street').hasError('maxlength')">
          {{ 'MSG_MAXLENGTH' | translate: {length: '50'} }}
        </mat-error>
      </mat-form-field>
    </div>

    <!-- image_original_uploaded_filename -->
    <div fxLayout>
      <mat-form-field>
        <input 
          matInput
          required
          readonly
          autocomplete="off" 
          #image_original_uploaded_filename 
          class="cursor-pointer"
          (click)="inputFile.click()" 
          formControlName="image_original_uploaded_filename" 
          [matTooltip]="formGroup.get('image_original_uploaded_filename').value"
          [placeholder]="'LABEL_LOGO' | translate"
          >

          <mat-icon 
            matSuffix
            svgIcon="attachment" 
            class="cursor-pointer"
            (click)="inputFile.click()" 
            [matTooltip]="'MSG_CHOOSE_FILE' | translate"
            *ngIf="formGroup.enabled"
            >
          </mat-icon>

        <mat-error *ngIf="formGroup.controls['image_original_uploaded_filename'].hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error> 
      </mat-form-field>
    </div>

    <!-- contact_person -->
    <div fxLayout>
      <mat-form-field>
        <input 
          matInput
          required
          #contact_person 
          autocomplete="off" 
          formControlName="contact_person" 
          [placeholder]="'LABEL_CONTACT_PERSON' | translate"
          >

        <mat-error *ngIf="formGroup.get('contact_person').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>   

        <mat-error *ngIf="formGroup.get('contact_person').hasError('maxlength')">
          {{ 'MSG_MAXLENGTH' | translate: {length: '50'} }}
        </mat-error>

        <mat-error *ngIf="formGroup.get('contact_person').hasError('pattern')">
          {{ 'MSG_NO_SPECIAL_CHARS' | translate }}
        </mat-error> 
      </mat-form-field>
    </div>

    <!-- contact_number -->
    <div fxLayout>
      <mat-form-field>
        <input 
          matInput
          required
          #contact_number 
          autocomplete="off" 
          formControlName="contact_number" 
          [placeholder]="'LABEL_CONTACT_NUMBER' | translate"
          >

        <mat-error *ngIf="formGroup.get('contact_number').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>   

        <mat-error *ngIf="formGroup.get('contact_number').hasError('maxlength')">
          {{ 'MSG_MAXLENGTH' | translate: {length: '16'} }}
        </mat-error>

        <mat-error *ngIf="formGroup.get('contact_number').hasError('pattern')">
          {{ 'MSG_NUMBERS_ONLY' | translate }}
        </mat-error> 
      </mat-form-field>
    </div>

    <!-- industry_type -->
    <esc-industry-type-dropdown
      class="width-100" 
      [formWrapperFlex]="'none'"
      [wrapperLayoutAlign]="'start center'"
      (optionSelected)="industryTypeSelected($event)"
      [previousData]="detail"
      [requiredError]="industryRequired"
      [disabled]="isDisabled"
      [isRequired]="true"
      >
    </esc-industry-type-dropdown>

    <!-- esc_sales_manager -->
    <div fxLayout>
      <mat-form-field>
        <input 
          matInput
          required
          #esc_sales_manager 
          autocomplete="off" 
          formControlName="esc_sales_manager" 
          [placeholder]="'LABEL_ESC_SALES_MANAGER' | translate"
          >

        <mat-error *ngIf="formGroup.get('esc_sales_manager').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>   

        <mat-error *ngIf="formGroup.get('esc_sales_manager').hasError('maxlength')">
          {{ 'MSG_MAXLENGTH' | translate: {length: '50'} }}
        </mat-error>

        <mat-error *ngIf="formGroup.get('esc_sales_manager').hasError('pattern')">
          {{ 'MSG_NO_SPECIAL_CHARS' | translate }}
        </mat-error> 
      </mat-form-field>
    </div>

    <!-- esc_project_manager -->
    <div fxLayout>
      <mat-form-field>
        <input 
          matInput
          required
          #esc_project_manager 
          autocomplete="off" 
          formControlName="esc_project_manager" 
          [placeholder]="'LABEL_ESC_PROJECT_MANAGER' | translate"
          >

        <mat-error *ngIf="formGroup.get('esc_project_manager').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>   

        <mat-error *ngIf="formGroup.get('esc_project_manager').hasError('maxlength')">
          {{ 'MSG_MAXLENGTH' | translate: {length: '50'} }}
        </mat-error>

        <mat-error *ngIf="formGroup.get('esc_project_manager').hasError('pattern')">
          {{ 'MSG_NO_SPECIAL_CHARS' | translate }}
        </mat-error> 
      </mat-form-field>
    </div>

    <!-- handling_fee -->
    <div fxLayout>
      <mat-form-field>
        <input 
          matInput
          required
          #handling_fee 
          autocomplete="off" 
          formControlName="handling_fee" 
          [placeholder]="'LABEL_HANDLING_FEE' | translate"
          >

        <mat-error *ngIf="formGroup.get('handling_fee').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>   

        <mat-error *ngIf="formGroup.get('handling_fee').hasError('max')">
          {{ 'MSG_MAX' | translate: {quantity: '100'} }}
        </mat-error>

        <mat-error *ngIf="formGroup.get('handling_fee').hasError('decimalErr')">
          {{ 'MSG_ERROR_DECIMAL_PLACES' | translate: {places: '2'} }}
        </mat-error> 
      </mat-form-field>
    </div>

    <!-- status / is_active -->
    <mat-checkbox formControlName="status">Active</mat-checkbox>
  </div>
</form>